import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param searchText
   */
  transform(items: any[], searchText: string): any {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.nameAlphabet.toLowerCase().includes(searchText) || it.name.toLowerCase().includes(searchText);
    });
  }
}


